import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-capacity-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './capacity-info.component.html',
  styleUrl: './capacity-info.component.css'
})
export class CapacityInfoComponent {
  capacity: any;  // Array to store the list of capacities
  capacityId: string | undefined; //Get the capacityId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the capacity ID from the route parameters
    this.route.params.subscribe(params => {
      this.capacityId = params['capacityId'];  // Workspace ID
    });
    // Fetch the capacity data when the component initializes
    this.dataFetcher.GetCapacityByIdData(this.capacityId).subscribe(
      (data: any) => {
        // Extract the 'capacities' array from the data object
        this.capacity = data.capacities[0] || null;  // Fallback to an empty array if 'capacities' is undefined
      },
      (error) => {
        console.error('Error fetching capacity data', error);
      }
    );
    console.log(this.capacity);
  }
}

